import React from 'react';
import CalendarCellGrid from './CalendarCellGrid';

const identity = (item) => item;

const CalendarPeriodCells = ({
  items,
  getKey = identity,
  getValue = identity,
  getLabel,
  getTestId,
  getExtra,
  isCurrent,
  isPicked,
  isDisabled,
  onPick,
  gridClassName = 'te-calendar-cells',
  cellClassName = 'te-calendar-cell',
  children
}) => {
  const cells = items.map((item) => ({
    key: getKey(item),
    value: getValue(item),
    label: getLabel(item),
    testId: getTestId(item),
    isToday: isCurrent(item),
    isSelected: isPicked(item),
    isDisabled: isDisabled(item),
    extra: getExtra?.(item)
  }));

  return (
    <CalendarCellGrid gridClassName={gridClassName} cellClassName={cellClassName} cells={cells} onPick={onPick}>
      {children}
    </CalendarCellGrid>
  );
};

export default CalendarPeriodCells;
